export default "__VITE_PUBLIC_ASSET__5557fd2d__"